import * as React from 'react';
import { connect } from 'react-redux';
import { AppConstants } from '../../constants/AppConstants';
import AppActions from '../../app/app_actions';
import * as agui from 'arm-gui/dist/controls';
import { Route, Link, Switch, Redirect } from "react-router-dom";
import ImpostazioniHome from './ImpostazioniHome.jsx';
import ImpostazioniSchemaDati from './impostazioniSchemaDati.jsx';
import { withRouter } from 'react-router';
import ImpostazioniParametri from './impostazioniParametri.jsx';
import Localizzazione from '../localizzazione/Localizzazione.jsx';
import LocalizzazioneDetails from '../localizzazione/LocalizzazioneDetails.jsx';
import LocalizzazioneCreate from '../localizzazione/LocalizzazioneCreate.jsx'


class ImpostazioniMasterPage extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = '[ImpostazioniMasterPage.jsx] ';
    }

    render() {
        console.log(this.componentName + ' render');
        return (
            <div className="row">
                <div className="col-sm-2 bg-light" >
                    <ul className="nav flex-column">
                        <li className="nav-item">
                            <a className="nav-link" href="#/impostazioni/home">Home</a>
                        </li>
                    </ul>
                </div>

                <div className="col-sm-10 mt-3" >
                    <Switch>
                        <Redirect exact="true" from="/impostazioni" to="/impostazioni/home" />
                        <Route path="/impostazioni/home" component={ImpostazioniHome} />
                        <Route path="/impostazioni/schemadati" component={withRouter(ImpostazioniSchemaDati)} />
                        <Route path="/impostazioni/parametri" component={withRouter(ImpostazioniParametri)} />
                        <Route path="/impostazioni/localizzazione" component={withRouter(Localizzazione)} />
                        <Route path="/impostazioni/localizzazioneDetails" component={LocalizzazioneDetails} />
                        <Route path="/impostazioni/localizzazioneCreate" component={LocalizzazioneCreate} />
                    </Switch>
                </div>
            </div>
        );
    }
};

/*
function mapStateToProps(state, ownProps) {
    return {
        deviceSize: state.app.deviceSize,
        changeURL: state.app.changeURL,
        currentURL: ownProps.location.pathname
    };
};
*/

//export default connect()(ImpostazioniMasterPage);;
export default ImpostazioniMasterPage;